import { RouteAPI } from '../mixins/route-api';
import { gaEvent } from '../mixins/ga-event';
import { AuthMixin } from '../mixins/auth';

export const UserAPI = {
  mixins: [RouteAPI, gaEvent, AuthMixin],
  data() {
    return {
      configHeader: {},
    };
  },
  created() {
    this.configHeader = {
      headers: {
        'X-CSRF-TOKEN': this.appConfig.csrfToken,
      },
    };
  },
  methods: {
    getBoomUser() {
      const url = this.appConfig.baseUrl + '/user/get-boom-user';
      return this.$http.get(url);
    },
    async loginAPI(data) {
      try {
        const res = await this.$http.post(this.routeAPILogin(), data, this.configHeader);
        if (res.data.status === 0) {
          this.googleManagerLogin(res.data.data.user.name);
          // this.setLogged();
        }
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async getUserInfoAPI() {
      try {
        const res = await this.$http.get(this.routeAPIGetUserInfo());
        return res.data;
      } catch (error) {
        console.log(error);
        // removeLogged();
        return {
          status: 0,
          message: 'Something went wrong!',
        };
      }
    },
    async logoutAPI() {
      try {
        const res = await this.$http.post(this.routeAPILogout(), {}, this.configHeader);
        if (res.data.status === 0) {
          // this.removeLogged();
        }
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },

    async registerAPI(data) {
      try {
        const res = await this.$http.post(this.routeAPIRegister(), data, this.configHeader);
        if (res.data.status === 0) {
          this.googleManagerCreateAccount(res.data.data.user.name);
          this.twitterTrackingCreateAccount();
          // this.setLogged();
        }
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },

    async updateAdminHighschoolAPI(data) {
      try {
        const res = await this.$http.post('/api/update-admin-school', data, this.configHeader);
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },

    async getRewardsFromAwardAPI() {
      try {
        const res = await this.$http.post(this.routeAPIGetRewardsFromAward(), {}, this.configHeader);
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async setUserzoneAPI(timezone) {
      try {
        await this.$http.post(this.routeAPISetUserzone(), {
          user_zone: timezone,
        }, this.configHeader);
      } catch (error) {
        console.log(error);
      }
    },
    async checkUserExistedAPI() {
      try {
        const res = await this.$http.get(this.routeAPICheckUserExisted());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async getConnectPlatformDataAPI() {
      try {
        const res = await this.$http.get(this.routeAPICheckConnectPlatformData());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async getAdminHub() {
      try {
        const res = await this.$http.get(this.routeAPIGetAdminSchoolHub());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async updateEmailTwitterAPI(email) {
      try {
        const res = await this.$http.post(this.routeAPIUpdateEmailTwitter(), {
          email: email,
        }, this.configHeader);
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async getHubInfoApi(userId) {
      try {
        const res = await this.$http.get(this.routeAPIHubInfo(), {
          params: {
            user_id: userId,
          },
        });
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async connectAccountAPI(game, gameName, tournamentId, platform) {
      try {
        console.log(this.configHeader);
        const res = await this.$http.post(this.routeAPISubmitGameName(), {
          game,
          game_name: gameName,
          tournament_id: tournamentId,
          platform,
        }, this.configHeader);
        return res.data;
      } catch (error) {
        console.log(error);
        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async getListMemberHub() {
      try {
        const res = await this.$http.get(this.routeAPIGetListMemberHub());
        return res.data;
      } catch (error) {
        console.log(error);
        // removeLogged();
        return {
          status: 0,
          message: 'Something went wrong!',
        };
      }
    },
    async getUserTournamentAdminUrl() {
      try {
        const res = await this.$http.get(this.routeAPIGetPersonalEventsUrl());
        return res.data;
      } catch (error) {
        console.log(error);
        // removeLogged();
        return {
          status: 0,
          message: 'Something went wrong!',
        };
      }
    },
    async getQueueupActiveGames() {
      try {
        const res = await this.$http.get(this.routeAPIGetQueueupActiveGames());
        return res.data;
      } catch (error) {
        console.log(error);
        // removeLogged();
        return {
          status: 0,
          message: 'Something went wrong!',
        };
      }
    },
    async getMyHub() {
      try {
        const res = await this.$http.get(this.routeAPIGetMyHub());
        return res.data;
      } catch (error) {
        console.log(error);
        // removeLogged();
        return {
          status: 0,
          message: 'Something went wrong!',
        };
      }
    },
  },
};
